import EventBus from "diagram-js/lib/core/EventBus";
import {hasPrimaryModifier} from 'diagram-js/lib/util/Mouse';
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";
import Selection from 'diagram-js/lib/features/selection/Selection';
import Canvas from "diagram-js/lib/core/Canvas";
import {OverlayType} from "@ispm/shared/bpmn-io/overlay-types";

export class ElementClickEventBehavior {
  private timer;
  private delay: number = 200;
  private prevent: boolean = false;

  constructor(protected eventBus: EventBus, private canvas: Canvas,
              private selection: Selection, private overlays) {
    this.addOnClick();
    this.addOnDoubleClick();
  }

  private selectionAction(event): any {
    let element = event.element;
    // do not select the root element
    // or connections
    if (element === this.canvas.getRootElement()) {
      element = null;
    }
    let isSelected = this.selection.isSelected(element);
    let isMultiSelect = this.selection.get().length > 1;

    // mouse-event: SELECTION_KEY
    let add = hasPrimaryModifier(event);

    // select OR deselect element in multi selection
    if (isSelected && isMultiSelect) {
      if (add) {
        return this.selection.deselect(element);
      } else {
        return this.selection.select(element);
      }
    } else
    if (!isSelected) {
      this.selection.select(element, add);
    } else {
      this.selection.deselect(element);
    }
  }

  private addOnClick(): any {
    this.eventBus.on(EventType.ELEMENT_CLICK, 3000, event => {
      this.timer = setTimeout(() => {
        if (!this.prevent) {
          this.selectionAction(event);
        }
        this.prevent = false;
      }, this.delay);
      return true;
    });
  }

  private addOnDoubleClick(): any {
    this.eventBus.on(EventType.ELEMENT_DBLCLICK, 2000, event => {
      clearTimeout(this.timer);
      this.prevent = true;

      const element = event.element;
      let selectedElements = this.selection.get();
      const oldSelection = selectedElements;
      selectedElements = [element];
      // since the SelectionChanged event is terminated whilst double-click we have to remove selection from all other
      // nodes and mark only the current one as selected
      oldSelection.forEach((selectedElement)=> {
        this.canvas.removeMarker(selectedElement,'selected');
        if(!!this.overlays) this.overlays.remove({element: selectedElement, type: OverlayType.nodeOpenNotesButtonOverlay});
      });
      this.selection._selectedElements = selectedElements;

      this.canvas.addMarker(element, 'selected');
    });
  }

}

ElementClickEventBehavior.$inject = ['eventBus','canvas','selection','overlays'];
